import React from "react";
import { 
  BarChart3, 
  Users, 
  LogOut,
  Home,
  FileText,
  Gift
} from "lucide-react";

interface SidebarProps {
  activeView: string;
  onViewChange: (view: string) => void;
  onLogout: () => void;
}

const Sidebar: React.FC<SidebarProps> = ({ activeView, onViewChange, onLogout }) => {
  const menuItems = [
    {
      id: "dashboard",
      label: "Dashboard",
      icon: <BarChart3 className="h-5 w-5" />,
      description: "Overview & Statistics"
    },
    {
      id: "users",
      label: "Users",
      icon: <Users className="h-5 w-5" />,
      description: "User Management"
    },
    {
      id: "blog",
      label: "Blog",
      icon: <FileText className="h-5 w-5" />,
      description: "Blog Management"
    },
    {
      id: "campaigns",
      label: "Discount Campaigns",
      icon: <Gift className="h-5 w-5" />,
      description: "Campaign Management"
    }
    // ,
    // {
    //   id: "subscriptions",
    //   label: "Subscriptions",
    //   icon: <UserCheck className="h-5 w-5" />,
    //   description: "Subscription Plans"
    // },
    // {
    //   id: "performance",
    //   label: "Performance",
    //   icon: <TrendingUp className="h-5 w-5" />,
    //   description: "System Metrics"
    // },
    // {
    //   id: "settings",
    //   label: "Settings",
    //   icon: <Settings className="h-5 w-5" />,
    //   description: "Admin Settings"
    // }
  ];

  return (
    <div className="h-full bg-gradient-to-b from-white to-orange-50 text-gray-800 flex flex-col shadow-xl border-r border-orange-200">
      {/* Logo/Header */}
      <div className="p-6 border-b border-orange-200 bg-white">
        <div className="flex items-center space-x-3">
          <div className="w-10 h-10 bg-gradient-to-br from-primary to-primary-dark rounded-lg flex items-center justify-center shadow-sm">
            <Home className="h-6 w-6 text-white" />
          </div>
          <div>
            <h1 className="text-lg font-bold text-gray-800">Plan My Plate</h1>
            <p className="text-xs text-primary font-medium">Admin Panel</p>
          </div>
        </div>
      </div>

      {/* Navigation Menu */}
      <nav className="flex-1 px-4 py-6 space-y-2">
        {menuItems.map((item) => (
          <button
            key={item.id}
            onClick={() => onViewChange(item.id)}
            className={`w-full flex items-center space-x-3 px-4 py-3 rounded-lg transition-all duration-200 group ${
              activeView === item.id
                ? "bg-gradient-to-r from-primary to-primary-dark text-white shadow-lg shadow-primary/25 border-l-4 border-accent"
                : "text-gray-600 hover:bg-gradient-to-r hover:from-accent-light hover:to-pink-100 hover:text-accent-dark"
            }`}
          >
            <div className={`flex-shrink-0 ${
              activeView === item.id ? "text-white" : "text-gray-500 group-hover:text-accent"
            }`}>
              {item.icon}
            </div>
            <div className="flex-1 text-left">
              <div className="text-sm font-medium">{item.label}</div>
              <div className={`text-xs ${
                activeView === item.id ? "text-orange-100" : "text-gray-400 group-hover:text-accent/80"
              }`}>
                {item.description}
              </div>
            </div>
          </button>
        ))}
      </nav>

      {/* Logout Button */}
      <div className="p-4 border-t border-orange-200 bg-white">
        <button
          onClick={onLogout}
          className="w-full flex items-center space-x-3 px-4 py-3 rounded-lg text-gray-600 hover:bg-gradient-to-r hover:from-red-500 hover:to-red-600 hover:text-white transition-all duration-200 group border border-gray-200 hover:border-red-500"
        >
          <LogOut className="h-5 w-5 text-gray-500 group-hover:text-white" />
          <span className="text-sm font-medium">Logout</span>
        </button>
      </div>
    </div>
  );
};

export default Sidebar;
